import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {RootState} from "../../../../../../store/store"

const chargerProfileSlice: any = createSlice({
    name: "chargerProfileDetails",
    initialState: {
        complaint_id: null,
        created_at: null,
        view_company_role: null,
    } as {
        complaint_id: null | number | undefined
        created_at: null | undefined
        view_company_role: null | string | undefined
    },
    reducers: {
        setChargerProfileDetails: (
            state,
            {
                payload: {complaint_id, created_at, view_company_role},
            }: PayloadAction<{
                complaint_id: null | number | undefined
                created_at: null | undefined
                view_company_role: null | string | undefined
            }>
        ) => {
            state.complaint_id = complaint_id
            state.created_at = created_at
            state.view_company_role = view_company_role
        },
    },
})

export const {setChargerProfileDetails} = chargerProfileSlice.actions

export default chargerProfileSlice.reducer
export const getChargerProfileDetails = (state: RootState) => state.chargerProfileDetails
